import {
  ResolveFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';

import {
  Observable,
  of
} from 'rxjs';

import {
  catchError,
  map
} from 'rxjs/operators';

import { inject } from '@angular/core';

import { DestinationsService } from '../../reducers/services/destinations.service';

export const HotelRouteDecisionResolver: ResolveFn<{
  type: string;
  data: any;
}> = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): Observable<{
  type: string;
  data: any;
}> => {

  const destinationsService =
    inject(DestinationsService);

  const hotelSlug =
    route.paramMap.get('slug');

  const destSegment =
    route.paramMap.get('destination');



  if (hotelSlug && destSegment) {

    return destinationsService
      .getActiveHotelBySlug(hotelSlug)
      .pipe(

        map((data: any) => {

          if (!data) {
            return {
              type: '404',
              data: null
            };
          }

          return {
            type: 'hotel',
            data
          };

        }),

        catchError((err) => {


          return of({
            type: '404',
            data: null
          });

        })

      );
  }


  if (hotelSlug === 'all') {

    return of({
      type: 'destination',
      data: 'all'
    });
  }

  if (hotelSlug) {


    return destinationsService
      .getDestinationBySlug(hotelSlug)
      .pipe(

        map((data: any) => {

          if (
            data &&
            (
              data._id ||
              data.slug ||
              data.name
            )
          ) {

            return {
              type: 'destination',
              data: hotelSlug
            };
          }

          return {
            type: '404',
            data: null
          };

        }),

        catchError((err) => {

          return of({
            type: '404',
            data: null
          });

        })

      );
  }

  // =========================================================
  // NO SLUG
  // =========================================================

  return of({
    type: '404',
    data: null
  });
};